import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import '@sapudex/web-components/dist/Button.js';
import {HeroComponent} from './hero.component';
import {ConfigModule, I18nModule} from '@spartacus/core';

import {CtaFormModule} from '../../cta-form/cta-form.module';

import {MediaModule, StarRatingModule} from '@spartacus/storefront';
import {ClassificationsTemplateModule} from '../classifications-template/classifications-template.module';
import {ReviewModule} from '../review/review.module';
import {HeroReviewComponent} from './hero-review/hero-review.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductHeroComponent: {
          component: HeroComponent,
        },
      },
    }),
    I18nModule,
    CtaFormModule,
    MediaModule,
    ClassificationsTemplateModule,
    StarRatingModule,
    ReviewModule,
    HeroComponent,
    HeroReviewComponent,
  ],
  exports: [HeroComponent],
})
export class HeroModule {}
